// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__3Q378","outer":"Loader_outer__1rheW","inner":"Loader_inner__1mRTD"};